export const Hamburger = () => {
  const $btn = document.querySelector('.js--hamburger');

  $btn.addEventListener('click', (e) => {
    e.preventDefault();

    const open = $btn.getAttribute('aria-expanded');
    const targetId = $btn.getAttribute('aria-controls');
    const $target = document.getElementById(`${targetId}`);

    if (open === 'true') {
      $btn.classList.remove('is-active');
      $btn.setAttribute('aria-expanded', 'false');
      $target.classList.remove('is-active');
      document.body.classList.remove('menu-open');
    } else {
      $btn.classList.add('is-active');
      $btn.setAttribute('aria-expanded', 'true');
      $target.classList.add('is-active');
      document.body.classList.add('menu-open');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
}
